'use client';
import { useState, useEffect, useContext } from "react";
import { useRouter } from "next/navigation";
import { getStoredUserData, clearSession, getQueryString } from "../../utils/utils";
import { ApiClient } from "../../utils/apiclient";
import { IMenuItem } from "../../utils/types";
import Sidebar from "../../components/sidebar";
import dynamic from "next/dynamic";
import SummaryCard from "../../components/summary_card";
// const ReactApexChart = dynamic(() => import("react-apexcharts"), { ssr: false })
import ReactApexChart from "react-apexcharts";
import SignoutDialog from "../../components/signout_dialog";
import { useNavigate } from "react-router-dom";
import NotificationView from "../../components/notification_view";
import { MdPerson } from "react-icons/md";

const Dashboard = (_props: any) => {
    console.log('my location:',window.location.pathname)
    const userData = getStoredUserData();
    const target = `${window.location.pathname}${getQueryString(window.location.href)}`
    const navigate = useNavigate()
    const [menuItems, setMenuItems] = useState<IMenuItem[]>([])
    const [notifications, setNotifications] = useState<Notification[]>([])

    //   const { showDialog, setShowDialog } = useContext(DialogContext);
    const [user, setUser] = useState<any>(userData)

    const handleSignout = () => {
        clearSession();
    }
    const options = {
        chart: {
            id: 'apexchart-example',
            title: {
                text: 'Number of Requests', style: {
                    fontSize: '14px',
                    fontWeight: 'bold',
                    fontFamily: undefined,
                    color: '#263238'
                },
            },
            toolbar: { show: false }

        },

        xaxis: {
            categories: [1991, 1992, 1993, 1994, 1995, 1996, 1997, 1998, 1999]
        }
    }

    const series = [{
        name: 'Fuel',
        data: [230, 140, 355, 50, 349, 160, 470, 391, 125]
    }, {
        name: 'Vehicle',
        data: [430, 440, 305, 550, 649, 360, 270, 591, 295].reverse()
    }, {
        name: 'Service',
        data: [130, 240, 135, 150, 149, 160, 170, 191, 125]
    }, {
        name: 'Maintenance',
        data: [310, 400, 335, 540, 419, 610, 720, 941, 1205]
    }]
    const options_ = {
        series: [44, 55, 13, 33],
        chartOptions: {
            labels: ['Apple', 'Mango', 'Orange', 'Watermelon']
        }
    }
    const options2 = {
        chart:{
            title:'Just a title',
            toolbar:{show:false}
        },
        
        labels: ["Maintenance", "Vehicle", "Service", "Fuel"]
        

    }
//    const series2: ,
        
    const getNotifications = async (userId: number) => {
        const apiClient = new ApiClient();
        const actionsRes = await apiClient.getNotifications(userData?.position as number);
        if (actionsRes.status == 200) {

            const notifications = actionsRes.data.notifications;
            console.log("🚀 ~ getNotifications ~ notifications:", actionsRes.data)
            setNotifications(notifications)
        }
    }
    const showNotifications = () => {
        navigate(`/notifications/${_props.user?.id}`)
    }
    useEffect(() => {
        if (userData) getNotifications(userData.id);
        else {
            // const target = `${window.location.pathname}${getQueryString(window.location.href)}`
            navigate('/login', { state: { targetPath: target } })
        }
    }, [])
    return (
        <main className="w-full flex bg-white min-h-screen">
            <div className="md:w-2/12 flex flex-col items-start text-center justify-center">
                <Sidebar notificationCount={notifications.length} user={userData} active={0} />
            </div>
            <div className="md:w-9/12 mx-auto space-y-4 mt-2">
            <div className="w-full flex justify-end items-center"><div className=" space-x-2 w-4/12 flex justify-end mt-0 items-center text-primary ">
                {/* <MdPerson className="hover:text-accent text-2xl"/> */}
                <p className="text-end py-4">{userData?.username}</p>
                <NotificationView count={_props.notificationCount} onNotificationClick={showNotifications} />
            </div></div>
            
                <div className="flex items-center justify-start md:space-x-2 mt-6">
                    <SummaryCard title="Total Requests" value={200} bg="orange" color="black-300" />
                    <SummaryCard title="Average Approval Time" value={'2h'} bg="blue" color="white-300" />
                    <SummaryCard title="Average Trip per Driver" value={"1500km"} bg="brown" color="white-300" />
                    <SummaryCard title="Total Maintenance Cost" value={'TZS2.6M'} bg="yellow" color="black-300" />
                </div>
                <div className="w-full border flex">
                    <ReactApexChart className="w-full" type="line" height={400} width={600} series={series} options={options} />
                    <ReactApexChart className="w-full" type="donut" height={400} width={600} options={options2} series={[200, 120, 460, 340]}/>
                </div>

                {/* <SignoutDialog title="Signout" msg="Are you sure you want to signout? Clicking sign out will end your session" show={showDialog} onCancel={()=>setShowDialog(false)}/> */}
            </div>


        </main>
    );

}
export default Dashboard;